import React, { useState } from 'react';
import { MessengerCallOverlay } from '../components/messaging/MessengerCallOverlay';

/**
 * Dev-only preview page for the redesigned call overlay. Cycles
 * through every state (incoming / calling / connecting / active /
 * reconnecting) so we can visually verify the animation, logo halo,
 * gradient backdrop and button styling without needing a real
 * WebRTC pair. Not wired into any nav — reachable via /dev/call-overlay
 * only. Safe to leave in production because the route is unlinked and
 * the overlay is stateful-only.
 */
export default function CallOverlayPreview() {
  const [status, setStatus] = useState('incoming');
  const [duration, setDuration] = useState(0);
  const [isMuted, setIsMuted] = useState(false);
  const [speakerOn, setSpeakerOn] = useState(true);

  React.useEffect(() => {
    if (status !== 'active') return undefined;
    const id = setInterval(() => setDuration((s) => s + 1), 1000);
    return () => clearInterval(id);
  }, [status]);

  const states = ['incoming', 'calling', 'connecting', 'active', 'reconnecting'];

  return (
    <div style={{ minHeight: '100vh', background: '#0f0a1a', color: 'white', padding: 20 }}>
      <div style={{ position: 'fixed', top: 20, left: 20, zIndex: 14000, display: 'flex', gap: 8, flexWrap: 'wrap', background: 'rgba(0,0,0,0.5)', padding: 10, borderRadius: 8 }}>
        {states.map((s) => (
          <button
            key={s}
            data-testid={`preview-state-${s}`}
            onClick={() => { setStatus(s); if (s === 'active') setDuration(0); }}
            style={{
              padding: '6px 10px',
              borderRadius: 6,
              background: status === s ? '#703FF6' : 'rgba(255,255,255,0.12)',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              fontSize: 12,
            }}
          >
            {s}
          </button>
        ))}
      </div>

      <MessengerCallOverlay
        open
        onMinimize={() => {}}
        onEnd={() => {}}
        onAccept={() => setStatus('active')}
        onDecline={() => setStatus('incoming')}
        onToggleMute={() => setIsMuted((m) => !m)}
        onToggleSpeaker={() => setSpeakerOn((s) => !s)}
        contactName="Maria K."
        contactImage={null}
        dataTestId="preview-call-overlay"
        status={status}
        durationSeconds={duration}
        isMuted={isMuted}
        speakerOn={speakerOn}
        socketConnected
      />
    </div>
  );
}
